import React from "react";

import ProductCardItem from "../ProductCardItem";

import "./style.css";

/**
 * Was an antd `Row`/`Col` whose column count came partly from a `resizeWidth`
 * prop, so the grid re-rendered on every resize step to pick between two
 * spans. An auto-fill grid tracks the container instead: same column counts at
 * the same widths, no JS, and it keeps working inside the narrower supplier
 * panel where the old fixed spans overflowed.
 */
const ProductCardsList = ({ products, material, showDistance, containerOption }) => (
  <div className="product-list-item">
    <div className="product-list-cards sy-grid sy-grid-sm">
      {products.map((item) => (
        <ProductCardItem
          key={item.id}
          product={item}
          material={material || item.containerMaterials[0]}
          showDistance={showDistance}
          containerOption={containerOption}
        />
      ))}
    </div>
  </div>
);

export default React.memo(ProductCardsList);
